module.exports = __webpack_public_path__ + "static/media/COVERO.e74b83cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/COVERO.svg
// module id = 47
// module chunks = 0